import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { GlobalVariable } from '../global';

@Component({
  selector: 'app-branch-details',
  templateUrl: './branch-details.page.html',
  styleUrls: ['./branch-details.page.scss'],
})
export class BranchDetailsPage implements OnInit {
@Input('branch')branch
  constructor(private modalController: ModalController,
    private router:Router,
    public globals: GlobalVariable,) { }

  ngOnInit() {
  }
ionViewWillEnter(){
  console.log(this.branch);

}
ionViewWillLeave(){
  // this.globals.businessData=null;
}
close(){
  this.modalController.dismiss();
}
// goToReviews(data){
//   this.close()
//   this.globals.businessData=data;
//   this.router.navigate(['reviews'])

// }
}
